import { useRef } from 'react';
import clsx from 'clsx';
import { useSelect } from '../hooks/useCoreContext';
import { Tag } from '@/shared/ui/tag';

type TriggerTagInputProps = {
	placeholder?: string;
	disabled?: boolean;
};

const TriggerTagInput = ({ placeholder, disabled }: TriggerTagInputProps) => {
	const {
		inputValue,
		onInputChange,
		setOpen,
		ids,
		open,
		refs,
		getReferenceProps,
		onEnter,
		dontOpenDropdownIfNoOptions,
		visibleOptions,
		selectedOptions,
		toggle,
	} = useSelect();

	const handleFocus = () => {
		const canOpen = !dontOpenDropdownIfNoOptions || (visibleOptions?.length ?? 0) > 0;
		if (canOpen) setOpen(true);
	};

	const inputRef = useRef<HTMLInputElement>(null);

	return (
		<div
			ref={refs.setReference}
			className={clsx(
				'rounded-xl px-4 py-2 w-full flex flex-wrap items-center gap-1 transition-colors relative min-h-11 h-auto cursor-text',
				'field-border',
				disabled && 'field-disabled',
				open && 'border-cuaternary',
			)}
			{...getReferenceProps({
				onClick: () => !disabled && inputRef.current?.focus(),
			})}
		>
			{selectedOptions.map((opt) => (
				<Tag
					key={opt.value}
					label={opt.label}
					onRemove={() => {
						if (!disabled) toggle(opt.value);
					}}
				/>
			))}
			<input
				ref={inputRef}
				autoComplete='off'
				type='search'
				id={ids.input}
				className={`border-none outline-none bg-transparent flex-1 min-w-20 text-secondary placeholder-text-tertiary`}
				value={inputValue}
				placeholder={selectedOptions.length === 0 ? placeholder : undefined}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChange(e.target.value)}
				onFocus={() => handleFocus()}
				onKeyDown={(e) => {
					if (e.key.length === 1 && !open) setOpen(true);
					if (e.key === 'Enter' && open) {
						e.preventDefault();
						if (disabled) return;
						e.stopPropagation();
						onEnter(e);
					}
				}}
				aria-autocomplete='list'
				disabled={disabled}
			/>
		</div>
	);
};

export default TriggerTagInput;
